import React, { useContext } from 'react';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-core';
import { UserType } from '@amzn/awscat-pattern-library-service-model';

import constants from '../../common/constants';
import BrowserHistory from '../utils/BrowserHistory';
import { AppContext } from '../../contexts/AppContext';
import RouterPaths from '../../common/RouterPaths';

const HeaderCreateDropdown = () => {
  const appContext = useContext(AppContext);
  const userProfile = appContext?.authnInfo?.userProfile;

  const dropDownItems = [{ text: constants.GUIDANCE, id: constants.GUIDANCE }];
  if (userProfile?.type === UserType.AWS) {
    dropDownItems.push({ text: constants.COLLECTION, id: constants.COLLECTION });
  }

  const handleDropdownClick = (event: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
    const eventId = event.detail.id;
    switch (eventId) {
      case constants.COLLECTION:
        BrowserHistory.push(RouterPaths.CREATE_COLLECTION);
        break;
      case constants.GUIDANCE:
        BrowserHistory.push(RouterPaths.CREATE_CONTENT);
        break;
      default:
        break;
    }
  };

  return (
    <ButtonDropdown items={dropDownItems} onItemClick={handleDropdownClick}>
      {constants.CREATE}
    </ButtonDropdown>
  );
};

export default HeaderCreateDropdown;
